import { Button, createStyles, makeStyles, Theme } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { Footer } from '../../../../../shared/components/Footer'
import { Header } from '../../../../../shared/components/Header'
import { LoadingAnimation } from '../../../../../shared/components/LoadingAnimation'
import { SharedDataProvider } from '../../../../../shared/providers/SharedDataProvider'
import { MachineType } from '../../../../models/MachineType'
import { MachineTypeSearchController } from '../../controllers/MachineTypeSearchController'
import { MachineTypeSearchResult } from './MachineTypeSearchResult'
import { SearchBar } from './SearchBar'

export const MachineTypes = (props) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      appContent: {
        minHeight: '86vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        alignItems: 'center',
      },
      seperator: {
        borderBottom: '1px solid lightgrey',
        marginTop: '10px',
        marginBottom: '10px',
      },
      dataContainer: {
        marginTop: 30,
        marginLeft: 20,
        marginRight: 20,
      },
      textfield: {
        margin: 0,
        width: 200,
        backgroundColor: 'white',
      },
      button: {
        width: 100,
        borderRadius: '10px',
        backgroundColor: '#1c8033',
        color: 'white',
        variant: 'contained',
        margin: 5,
        fontSize: 15,
        '&:hover': {
          backgroundColor: '#1c8033',
        },
      },
      buttonLoadMore: {
        backgroundColor: '#ffffff',
        color: 'black',
        variant: 'contained',
        padding: 10,
        marginTop: 10,
        '&:hover': {
          backgroundColor: '#eeeeee',
        },
      },
      searchResultMainData: {
        color: '#212121',
        fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
        fontSize: 16,
        textAlign: 'left',
      },
      companyAndMachineTypeContainer: {
        display: 'flex',
        justifyContent: 'center',
      },
      companyAndMachineTypeDisplay: {
        display: 'flex',
        flexDirection: 'column',
        marginRight: 20,
        marginLeft: 20,
      },
      searchResults: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        marginBottom: 20,
      },
      companyLogo: {
        objectFit: 'contain',
        objectPosition: 'center',
        height: '120px',
        width: '180px',
      },
      machineTypePicture: {
        objectFit: 'contain',
        objectPosition: 'center',
        height: '120px',
        borderRadius: '50%',
      },
    })
  )
  const classes = useStyles()

  const machineTypeSearchController: MachineTypeSearchController = new MachineTypeSearchController(
    props.history
  )
  const sharedDataProvider = new SharedDataProvider()

  const [companyId, setCompanyId] = useState('')
  const [machineTypes, setMachineTypes] = useState<MachineType[]>([])

  const [isLoading, setIsLoading] = useState(true)

  const [latestSearchValue, setLatestSearchValue] = useState('')
  const [latestSearchProperty, setLatestSearchProperty] = useState('')
  let [searchIndexFrom, setSearchIndexFrom] = React.useState(0)
  let [searchIndexTo, setSearchIndexTo] = React.useState(20)
  let [
    totalNumberOfSearchResults,
    setTotalNumberOfSearchResults,
  ] = React.useState(0)

  async function getBatchOfMachineTypes(
    searchValue: string,
    searchProperty: string,
    newSearch: Boolean,
    companyId: string
  ) {
    if (newSearch === true) {
      setIsLoading(true)
      let searchResult = await machineTypeSearchController.searchForMachineTypes(
        companyId,
        searchValue,
        searchProperty,
        0,
        20
      )

      setSearchIndexFrom(0)
      setSearchIndexTo(20)

      let machineTypes = searchResult.machineTypes
      let totalNumberOfSearchResults = searchResult.totalNumberOfSearchResults

      setMachineTypes(machineTypes)
      setTotalNumberOfSearchResults(totalNumberOfSearchResults)
      setLatestSearchValue(searchValue)
      setLatestSearchProperty(searchProperty)
    } else {
      let searchResult = await machineTypeSearchController.searchForMachineTypes(
        companyId,
        searchValue,
        searchProperty,
        searchIndexFrom + 20,
        searchIndexTo + 20
      )

      setSearchIndexFrom(searchIndexFrom + 20)
      setSearchIndexTo(searchIndexTo + 20)

      let nextMachineTypes = searchResult.machineTypes

      setMachineTypes([...machineTypes, ...nextMachineTypes])
    }

    setIsLoading(false)
  }

  useEffect(() => {
    let getAllMachineTypes = async () => {
      const { params } = props.match
      setCompanyId(params.companyId)
      getBatchOfMachineTypes('', 'name', true, params.companyId)
    }
    getAllMachineTypes()
  }, [])

  return (
    <div>
      <Header
        page={'machineTypes'}
        history={props.history}
        selectedLanguage={props.selectedLanguage}
        setSelectedLanguage={props.setSelectedLanguage}
      />

      <div className={classes.appContent}>
        <div className={classes.dataContainer}>
          <SearchBar
            getBatchOfMachineTypes={getBatchOfMachineTypes}
            companyId={companyId}
            history={props.history}
            selectedLanguage={props.selectedLanguage}
          />
        </div>

        {isLoading ? (
          <div className={classes.dataContainer}>
            <LoadingAnimation />
          </div>
        ) : (
          <div className={classes.dataContainer}>
            <div className={classes.dataContainer}>
              <div className={classes.searchResultMainData}>
                {totalNumberOfSearchResults}
                {
                  {
                    de: ' Ergebnisse',
                    en: ' Results',
                    fr: ' Ergebnisse - FR',
                  }[props.selectedLanguage]
                }
              </div>
            </div>
            <div className={classes.seperator}></div>
            <div className={classes.dataContainer}>
              <div className={classes.searchResults}>
                {machineTypes.map((machineType) => (
                  <MachineTypeSearchResult machineType={machineType} />
                ))}

                {searchIndexTo < totalNumberOfSearchResults ? (
                  <Button
                    className={classes.buttonLoadMore}
                    onClick={() => {
                      getBatchOfMachineTypes(
                        latestSearchValue,
                        latestSearchProperty,
                        false,
                        companyId
                      )
                    }}
                  >
                    {
                      {
                        de: 'mehr laden',
                        en: 'load more',
                        fr: 'mehr laden - FR',
                      }[props.selectedLanguage]
                    }
                  </Button>
                ) : null}
              </div>
            </div>
          </div>
        )}
      </div>

      <Footer
        history={props.history}
        selectedLanguage={props.selectedLanguage}
      />
    </div>
  )
}
